import { render, staticRenderFns } from "./Questionsurvey.vue?vue&type=template&id=0af03c64&scoped=true"
import script from "./Questionsurvey.vue?vue&type=script&lang=js"
export * from "./Questionsurvey.vue?vue&type=script&lang=js"
import style0 from "./Questionsurvey.vue?vue&type=style&index=0&id=0af03c64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af03c64",
  null
  
)

export default component.exports